import {
  createOAuthClient,
  createToken,
} from "@axioscode/api-client/lib/utils/auth";

import { OAUTH, BACKEND_ROOT } from "config/constants";

/**
 * Deserializes data from a string to a Collection that can be stored in Redux
 * @param {Collection} subset - some subset of state (governed by the paths passed to persistState)
 * @returns {string} serializedData - the state subset serialized to a string
 */
export const serialize = subset => {
  const serializableSubset = subset;

  if (subset.client && Object.keys(subset.client).length) {
    // The client instance can't be persisted to localstorage.
    // Instead, we persist just the nonce for recreation on deserialization.
    serializableSubset.client = {
      nonce: subset.client.options.state,
    };
  }

  if (subset.token && Object.keys(subset.token).length) {
    // The token instance can't be persisted to localstorage.
    // Instead, we persist just the token's string value, expiry and data for recreation on deserialization.
    serializableSubset.token = {
      accessToken: subset.token.accessToken,
      data: subset.token.data,
    };
  }

  return JSON.stringify(serializableSubset);
};

/**
 * Deserializes data from a string to a Collection that can be stored in Redux
 * @param {string} serializedData
 * @returns {Collection} subset - The deserialized state subset (will be inserted into the `path` keys)
 */
export const deserialize = serializedData => {
  const deserializedData = JSON.parse(serializedData);

  if (
    deserializedData &&
    deserializedData.client &&
    deserializedData.client.nonce
  ) {
    // Enrich persisted client nonce by turning it into a real client instance
    deserializedData.client = createOAuthClient(
      OAUTH.CLIENT_ID,
      BACKEND_ROOT,
      OAUTH.SCOPES,
      deserializedData.client.nonce
    );
  }

  if (
    deserializedData &&
    deserializedData.token &&
    deserializedData.token.accessToken &&
    deserializedData.token.data
  ) {
    // Enrich persisted access token by turning it into a real token instance
    if (!deserializedData.client) {
      throw new Error(
        "cannot deserialize a token without a client in state as well"
      );
    }
    deserializedData.token = createToken(
      deserializedData.client,
      deserializedData.token.accessToken,
      deserializedData.token.data
    );
  }

  return deserializedData;
};
